/**
 * Created by toomasp on 28.07.2015.
 */
export let services = angular.module('eservice.core.services', []);

import {CasService} from "./AuthenticationService";
import {signatureService} from "./SignatureService";
import {LoaderContext} from "./LoaderContext";

services.value('signatureService', signatureService);
services.service('loaderContext', LoaderContext);
services.service('casService', CasService);



// WEBPACK FOOTER //
// ./src/main/ui/core/services/services.ts